import styled from 'styled-components'

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: 24px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MetricGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const MetricRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const MetricLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 6px;
`

export const MetricValue = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: right;
`

export const MetricHighlight = styled.div<{
  $type?: 'success' | 'warning' | 'danger' | 'info' | 'default'
}>`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  background: ${({ $type }) => {
    switch ($type) {
      case 'success':
        return '#10b98115'
      case 'warning':
        return '#f59e0b15'
      case 'danger':
        return '#ef444415'
      case 'info':
        return '#3b82f615'
      default:
        return '#f8f9fa'
    }
  }};
  color: ${({ $type }) => {
    switch ($type) {
      case 'success':
        return '#10b981'
      case 'warning':
        return '#f59e0b'
      case 'danger':
        return '#ef4444'
      case 'info':
        return '#3b82f6'
      default:
        return 'inherit'
    }
  }};
`
